import { csx } from '@vtex/admin-ui'

export const styles = {
  nagivateButton: csx({
    marginLeft: '-0.75rem',
  }),
  tag: csx({
    display: 'inline-block',
  }),
  content: csx({
    paddingBottom: '$space-1',
  }),
}
